import { generateUuid } from '@lib/uuid';

interface GetCollectIdProps {
  collectType: 'block' | 'topbar' | 'hero' | 'footer';
  collectItemId?: string;
}

export const createCollectId = ({ collectType, collectItemId }: GetCollectIdProps) => {
  return `${collectType}${collectItemId != null ? `#${collectItemId}` : ''}#${generateUuid().substr(0, 8)}`;
};
